export class Navigation {
	constructor() {
		this.open = false
		this.toggle = document.querySelectorAll('[data-toggle-nav]')

		this.toggle.forEach((button) => {
			button.addEventListener('click', () => {
				this.open ? this.closeNavigation() : this.openNavigation()
			})
		})

		this.setActiveState()
	}
	openNavigation() {
		this.open = true
		document.documentElement.classList.add('nav-open')
		document.documentElement.setAttribute('data-nav-status', 'open')
	}
	closeNavigation() {
		this.open = false
		document.documentElement.classList.remove('nav-open')
		document.documentElement.setAttribute('data-nav-status', 'closed')
	}
	snapCloseNavigation() {}
	setActiveState() {

    const url = window.location.href
    const menuItems = document.querySelectorAll('.menu-item a, .menu-item span')

    menuItems.forEach(item => {
			const parentId = item.getAttribute('data-parent-id')

      item.parentElement.classList.remove('current')

			if (parentId && item.href && item.href == url) {
				const parentItem = document.querySelector(`[data-id="${parentId}"]`)

				if (parentItem) {
					parentItem.classList.add('current')
				}
			}
			
      if (item.href && item.href == url) {
        item.parentElement.classList.add('current')
      }
    })
  }
}